// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"188768ef","639":"473d0264"}[chunkId] + ".chunk.css";
};